import React from 'react';
import classNames from 'classnames';
import { BzImage } from '@benzinga/image';
import { Image } from '@benzinga/article-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './ImagePlacement.module.scss';

export interface ImagePlacementProps {
  title?: string;
  caption?: string;
  primaryImage: Image;
}

export const ImagePlacement: React.FC<ImagePlacementProps> = ({ caption, primaryImage, title }) => {
  const alt = caption || '';
  if (primaryImage) {
    const primaryImageURL = primaryImage.url?.replace('//www.benzinga', '//cdn.benzinga');
    return (
      <figure className={classNames(styles.container, 'image-placement')}>
        <div className="article-image bg-gray-100">
          <BzImage
            alt={alt}
            blurDataURL={`${primaryImageURL}?width=50`}
            height={378}
            layout="fill"
            objectFit="cover"
            preload={true}
            sizes="(max-width: 800px) 120px, (min-width: 800px) 400px"
            src={primaryImageURL}
            title={title}
            width={700}
          />
        </div>
        {caption && (
          <figcaption className="image-caption" dangerouslySetInnerHTML={{ __html: sanitizeHTML(caption) }} />
        )}
      </figure>
    );
  }

  return <div />;
};
